export default __webpack_public_path__ + "static/media/About-Tower-viajes-2@3x.1786def5.jpg";